// extracted by mini-css-extract-plugin
module.exports = {"detailedNavOuter":"detailed-nav_detailedNavOuter__yedNI","detailedNavInner":"detailed-nav_detailedNavInner__qkxB_","showDetailedNav":"detailed-nav_showDetailedNav__ll434"};